export const QRCode = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.5 17V17.01M7.5 7V7.01M17.5 7V7.01M17.5 14H14.5V17M20.5 14V14.01M14.5 20H17.5M17.5 17H20.5V20M5.5 4H9.5C10.0523 4 10.5 4.44772 10.5 5V9C10.5 9.55228 10.0523 10 9.5 10H5.5C4.94772 10 4.5 9.55228 4.5 9V5C4.5 4.44772 4.94772 4 5.5 4ZM15.5 4H19.5C20.0523 4 20.5 4.44772 20.5 5V9C20.5 9.55228 20.0523 10 19.5 10H15.5C14.9477 10 14.5 9.55228 14.5 9V5C14.5 4.44772 14.9477 4 15.5 4ZM5.5 14H9.5C10.0523 14 10.5 14.4477 10.5 15V19C10.5 19.5523 10.0523 20 9.5 20H5.5C4.94772 20 4.5 19.5523 4.5 19V15C4.5 14.4477 4.94772 14 5.5 14Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)
